import { render, staticRenderFns } from "./add-sider.vue?vue&type=template&id=00c4631d&scoped=true"
import script from "./add-sider.vue?vue&type=script&lang=js"
export * from "./add-sider.vue?vue&type=script&lang=js"
import style0 from "./add-sider.vue?vue&type=style&index=0&id=00c4631d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c4631d",
  null
  
)

export default component.exports